<template>
  <v-card variant="flat" :color="$props.color" class="flex_chip">
    <v-card-title>
      {{ $props.title.toString() }}
    </v-card-title>
    <v-card-subtitle>
      {{ $props.subtitle }}
    </v-card-subtitle>
  </v-card>
</template>

<script setup lang="ts">
defineProps<{
  title: string | number
  subtitle: string
  color: string
}>()
</script>

<style scoped lang="scss">
.v-card-title {
  font-size: 14px !important;
  padding-bottom: 0;
  padding-top: 0;
}
.v-card-subtitle {
  font-size: 12px !important;
}
.flex_chip {
  flex-basis: 100%;
  text-align: center;
}
</style>
